module.exports = __webpack_public_path__ + "my-photo.png?b86deddb8fc8e5ba1a912ce44ce0b73a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my-photo.png
// module id = 43
// module chunks = 0